import {
  getUnreadNotification,
  markNotificationRead,
} from '@/services/v1/massConsult';

export default {
  async FETCH_NOTIFICATION({ commit }) {
    try {
      const { data } = await getUnreadNotification();
      const payload = data?.data;

      if (payload && payload.schedule_id) {
        commit('SET_NOTIFICATION', {
          schedule_id: payload.schedule_id,
          read_at: payload.notification_read_at ?? null,
        });
      } else {
        commit('CLEAR_NOTIFICATION');
      }
    } catch (err) {
      commit('CLEAR_NOTIFICATION');
    }
  },

  RECEIVE_COMPLETED({ commit }, { schedule_id }) {
    commit('SET_NOTIFICATION', { schedule_id, read_at: null });
  },

  async MARK_READ({ commit, state }) {
    if (!state.notification) return;

    const { schedule_id } = state.notification;
    commit('CLEAR_NOTIFICATION'); // otimista: badge some imediatamente (RN007/CA04)

    try {
      await markNotificationRead(schedule_id);
    } catch (err) {
      // estado de verdade volta do backend no próximo FETCH_NOTIFICATION
    }
  },
};
